/* Herlamora color shop — panel hydration.

   The startseite-* colour collections are pure VCM order lists whose
   products are not collection members, so the inline render depends on
   all_products (20 unique handles per page). On the busy frontpage the
   cap truncates most panels. Each panel therefore re-fetches itself as
   /collections/<handle>?section_id=hcl-panel — a standalone section
   render with a fresh handle budget — and swaps in the complete
   featured tile + card list. The inline render stays as the fallback
   when a fetch fails. */
(() => {
  const hydratePanel = (panel, limit) => {
    const url = `${panel.dataset.panelUrl}?section_id=hcl-panel`;
    return fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const featured = doc.querySelector('[data-hcl-featured-content]');
        const cards = doc.querySelector('[data-hcl-cards]');
        if (!featured || !cards || cards.children.length === 0) return;

        const featuredTarget = panel.querySelector('.hcl__featured');
        if (featuredTarget && featured.children.length) {
          featuredTarget.replaceChildren(...featured.children);
        }

        const row = panel.querySelector('.hcl__row');
        if (row) {
          /* the card snippets interleave their <link> stylesheet tags
             between the <li>s — keep only the cards (the section
             already loads the card CSS) */
          const items = [...cards.children].filter((el) => el.tagName === 'LI');
          const trimmed = Number.isNaN(limit) ? items : items.slice(0, limit);
          /* the ul itself stays — the slider element's scroll/arrow
             listeners remain bound */
          row.replaceChildren(...trimmed);
          row.dispatchEvent(new Event('scroll'));
        }

        if (typeof initializeScrollAnimationTrigger === 'function') {
          initializeScrollAnimationTrigger(panel.parentElement || panel);
        }
      })
      .catch(() => {
        /* keep the inline fallback */
      });
  };

  const init = () => {
    document.querySelectorAll('.hcl').forEach((section) => {
      const limit = parseInt(section.dataset.productsToShow || '', 10);
      const panels = [...section.querySelectorAll('.hcl__panel[data-panel-url]')];
      if (panels.length === 0) return;
      /* visible panel first, the rest staggered so tab switches are
         instant without stampeding the section endpoint */
      const active = panels.find((panel) => !panel.hidden) || panels[0];
      hydratePanel(active, limit).then(() => {
        panels
          .filter((panel) => panel !== active)
          .forEach((panel, index) => {
            window.setTimeout(() => hydratePanel(panel, limit), 250 * (index + 1));
          });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
